export default "__VITE_ASSET__dbb81e34__"